<template>
  <v-app>
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="10" md="6">
            <v-card class="mx-auto mt-5">
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title>Signing you in…</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-progress-linear indeterminate color="primary" class="mb-4" />
                <div v-if="error_text" style="color: #b71c1c">{{ error_text }}</div>
                <div v-else>Completing single sign-on…</div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'sign-in-sso',
  mounted() {
    try {
      const code = this.$route.query.code;
      const state = this.$route.query.state;
      if (!code || !state) {
        this.error_text = 'Missing code or state';
        return;
      }

      this.$rc.rest({
        spinner: true,
        endpoint: `GET: /api/v1/auth/sso/callback?code=${encodeURIComponent(code)}&state=${encodeURIComponent(state)}`,
        on_success: (data) => {
          // Set flag to prevent unauthorized redirects during SSO completion
          this.$rc.setSSOCompletionInProgress(true);

          // Store the profile data but avoid triggering side effects that could cause 401s
          this.$rc.$state.updateProfile(data);

          // Small delay to ensure auth token is properly set before making any additional API calls
          setTimeout(() => {
            // Immediately re-validate to get canonical profile and ensure auth header works
            this.$rc.rest({
              spinner: false,
              endpoint: 'GET: /api/v1/auth/validate',
              params: {},
              on_success: (validated) => {
                // Update profile with validated data, but avoid side effects during SSO completion
                this.$rc.$state.updateProfile(validated);

                // Clear the SSO completion flag
                this.$rc.setSSOCompletionInProgress(false);

                // Handle post-sign-in redirects consistent with normal sign-in
                const front_end_link_id = localStorage.getItem('rc_after_sign_in_front_end_link_id');
                const rc_after_sign_in_url = localStorage.getItem('rc_after_sign_in_url');
                localStorage.removeItem('rc_after_sign_in_front_end_link_id');
                localStorage.removeItem('rc_after_sign_in_url');

                if (rc_after_sign_in_url) {
                  window.location = rc_after_sign_in_url;
                  return;
                }
                if (front_end_link_id) {
                  this.$router.push({
                    name: 'short_link_router',
                    params: { front_end_link_id }
                  });
                  return;
                }
                this.$router.push({ name: 'home' });
              },
              on_error: (resp) => {
                // Clear the SSO completion flag even on error
                this.$rc.setSSOCompletionInProgress(false);

                // If revalidate fails for any reason, fall back to using the initial profile
                const front_end_link_id = localStorage.getItem('rc_after_sign_in_front_end_link_id');
                const rc_after_sign_in_url = localStorage.getItem('rc_after_sign_in_url');
                localStorage.removeItem('rc_after_sign_in_front_end_link_id');
                localStorage.removeItem('rc_after_sign_in_url');

                if (rc_after_sign_in_url) { window.location = rc_after_sign_in_url; return; }
                if (front_end_link_id) { this.$router.push({ name: 'short_link_router', params: { front_end_link_id } }); return; }
                this.$router.push({ name: 'home' });
              },
            });
          }, 100); // Small delay to ensure auth state is stable
        },
        on_error: (resp) => {
          // Clear the SSO completion flag on error
          this.$rc.setSSOCompletionInProgress(false);

          this.$rc.updateProfile({});
          let message = (resp?.message || 'Unable to complete SSO sign-in') + '. Moving back to sign in.';
          this.error_text = message;
          //Send back to standard login after 5 seconds
          setTimeout(() => {
            this.$router.push({ name: 'sign-in' });
          }, 5000);
        },
      });
    } catch (e) {
        // Clear the SSO completion flag on error
        this.$rc.setSSOCompletionInProgress(false);

        let message = e?.message || 'Unexpected error' + '. Moving back to sign in.';
        this.error_text = message;
        //Send back to standard login after 5 seconds
        setTimeout(() => {
          this.$router.push({ name: 'sign-in' });
        }, 5000);
    }
  },
  data() {
    return {
      error_text: null,
    };
  },
};
</script>

<style scoped>
</style>

